/**Tipo di contante, può essere una banconota o una moneta */
export enum CashTypeEnum {
    Unknown = 0,
    Banknote = 1,
    Coin = 2,
    All = 3,
}

export function cashTypeEnumLabel(value: CashTypeEnum): string {
    switch (value) {
        case CashTypeEnum.Banknote:
            return "enum.cashType.banknote";
        case CashTypeEnum.Coin:
            return "enum.cashType.coin";
        case CashTypeEnum.All:
            return "enum.cashType.all";
        default:
            return "common.unknown";
    }
}
